import { memo } from 'react'

import { useDispatch, useSelector } from '@tabeeb/store'

import { Button, ConfirmationDialog, useDialogState } from '@collaborate-health/uikit'
import { getFormButtonState } from '@tabeeb/modules/forms/selectors'
import { getContentId } from '@tabeeb/modules/shared/content/selectors'
import { sendForInContentReviewRequest } from '@tabeeb/modules/contentReviews/actions'
import { useFormTitleFormatter } from '@tabeeb/modules/shared/utils/text'

import { FormButtons } from '../../services/enums'

const SendForInContentReviewButton: React.FC = () => {
  const dispatch = useDispatch()
  const [open, onOpen, onClose] = useDialogState()

  const { isVisible, isDisabled } = useSelector((state) =>
    getFormButtonState(state, { button: FormButtons.SendForInContentReview })
  )

  const contentId = useSelector(getContentId)
  const { f } = useFormTitleFormatter()

  if (!isVisible) {
    return null
  }

  return (
    <>
      <Button size='small' variant='contained' color='primary' fullWidth disabled={isDisabled} onClick={onOpen}>
        Submit for review
      </Button>

      <ConfirmationDialog
        isOpen={open}
        cancelButtonText='Close'
        submitButtonText='Ok'
        title={f(`Would you like to submit forms for review?`)}
        onCloseDialog={onClose}
        onSubmit={() => {
          dispatch(sendForInContentReviewRequest({ contentId }))
          onClose()
        }}
      />
    </>
  )
}

export default memo(SendForInContentReviewButton)

